import { IReportEmbedConfiguration } from 'embed';
import { models } from 'powerbi-client';

export interface RefreshState {
  id: string;
  lastRefreshTime: string,
  status: RefreshStatus;
}

export declare type RefreshStatus = 'Unknown' | 'InProgress' | 'Failed' | 'Success' | 'Completed';
export declare type ReportType = 'PowerBIReport' | 'PaginatedReport';
// TODO TTT-4611 Use bi reports configuration instead
export declare type ReportName =
  'assetReport'
  | 'organizationReport'
  | 'workReport'
  | 'workPaginatedReport'
  | 'assetWorkPaginatedReport'
  | 'equipmentReport'
  | 'equipmentPaginatedReport'
  | 'assetEquipmentPaginatedReport'
  | 'spaceReport'
  | 'projectReport'
  | 'investmentReport'
  | 'analysisReport';
// TODO TTT-4611 Use bi reports configuration instead
export declare type ReportPageName =
  'assetReportDefaultPage'
  | 'organizationReportDefaultPage'
  | 'workReportDefaultPage'
  | 'equipmentReportDefaultPage'
  | 'spaceReportDefaultPage'
  | 'projectReportDefaultPage'
  | 'investmentReportDefaultPage'
  | 'analysisReportDefaultPage';

export class PowerBiReportConfig implements IReportEmbedConfiguration {
  public type = 'report';
  public tokenType = models.TokenType.Embed;
  public filters = [];
  public settings = {
    panes: {
      filters: {
        expanded: false,
        visible: false
      },
      pageNavigation: {
        visible: false
      },
      background: models.BackgroundType.Transparent
    }
  };

  /**
   * Build an embed Power BI filter config
   * @param table table on which the filter will be applied
   * @param column property to filter on.
   * @param value value to match.
   * @returns An embed Power BI filter config
   */
  public static buildFilter(table: string, column: string, value: string): any {
    return {
      $schema: 'http://powerbi.com/product/schema#basic',
      target: {
        table,
        column
      },
      operator: 'In',
      values: [value],
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    };
  }
}

export interface PowerBiReport {
  id: string;
  type: ReportType;
  name: string;
}

export interface PageBiReport {
  id: string;
  name: string;
}

export interface Dataflow {
  id: string;
  name: string;
}

export interface Environment {
  id: string;
  name: string;
  workspaceId: string;
  sharepointId: string;
  isDefault: boolean;
}
